import to from "await-to-js";
import { useState, useEffect, FC } from "react";

import { poreskaUpravaService } from "../../../../modules/poreskaUprava/poreskaUprava.service";

import style from "./PuObrazac.module.scss";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { IPuObrazac } from "../../../../modules/poreskaUprava/poreskaUprava.types";
import { useNavigate } from "react-router-dom";
import { authService } from "../../../../modules/auth/auth.service";
import { RollbackOutlined } from "@ant-design/icons";
import { GoBackButton } from "../../../../components/GoBackButton/GoBackButton";

interface ILabelValueRowProps {
  label: string;
  value: string | number | null | undefined;
}

const LabelValueRow: FC<ILabelValueRowProps> = ({ label, value }) => {
  const { t } = useTranslation();
  return (
    <Row className={style.labelValueRow}>
      <div className={style.label}>{t(`PU_OBRASCI.${label}`)}:</div>
      <div className={style.value}>{value}</div>
    </Row>
  );
};

interface IObrazacSectionConfig {
  sectionLabel: string;
  labelValueRows: ILabelValueRowProps[];
}

const ObrazacSection: FC<IObrazacSectionConfig> = ({
  sectionLabel,
  labelValueRows,
}) => {
  const { t } = useTranslation();
  return (
    <Row className={style.row}>
      <Col span={12} className={style.leftCol}>
        {t(`PU_OBRASCI.${sectionLabel}`)}
      </Col>
      <Col span={12} className={style.rightCol}>
        {labelValueRows.map(({ label, value }) => (
          <LabelValueRow label={label} value={value} />
        ))}
      </Col>
    </Row>
  );
};

export const PuObrazac = () => {
  const { t } = useTranslation();
  const [obrazac, setObrazac] = useState<IPuObrazac | null>(null);

  const goBackRoute = authService
    .getRole()
    .some((role) => role.includes("MFIN"))
    ? "/mfin/puObrasci"
    : "/obveznik/puObrasci";

  const getObrazac = async (obrazacId: string | null) => {
    if (!obrazacId) return;
    const [err, res] = await to(
      poreskaUpravaService.getSinglePuObrazac(+obrazacId)
    );
    if (err || !res.success) return;
    setObrazac(res.data);
  };

  useEffect(() => {
    let queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");

    getObrazac(id);
  }, []);

  const obrazacSectionConfig: IObrazacSectionConfig[] = [
    {
      sectionLabel: "OPSTI_PODACI",
      labelValueRows: [
        {
          label: "BROJ_JCI",
          value: obrazac?.opstiPodaci.brojJci,
        },
        {
          label: "DATUM_CARINJENJA",
          value: obrazac?.opstiPodaci.datumCarinjenja,
        },
        {
          label: "SIFRA_CARINSKE_ISPOSTAVE",
          value: obrazac?.opstiPodaci.sifraCarinskeIspostave,
        },
      ],
    },
    {
      sectionLabel: "PODACI_O_UVOZNIKU",
      labelValueRows: [
        {
          label: "PIB",
          value: obrazac?.uvoznik.pib,
        },
        {
          label: "NAZIV_I_ADRESA",
          value: obrazac?.uvoznik.nazivIAdresa,
        },
      ],
    },
    {
      sectionLabel: "PODACI_O_IZVOZNIKU",
      labelValueRows: [
        {
          label: "NAZIV",
          value: obrazac?.izvoznik.naziv,
        },
        {
          label: "ZEMLJA",
          value: obrazac?.izvoznik.zemlja,
        },
      ],
    },

    {
      sectionLabel: "PODACI_O_SPEDITERU",
      labelValueRows: [
        {
          label: "PIB",
          value: obrazac?.spediter.pib,
        },
        {
          label: "NAZIV_I_ADRESA",
          value: obrazac?.spediter.nazivIAdresa,
        },
      ],
    },
    {
      sectionLabel: "PODACI_O_PREVOZNOM_SREDSTVU",
      labelValueRows: [
        {
          label: "IDENTITET_PREVOZNOG_SREDSTVA",
          value: obrazac?.prevoznoSredstvo.identitetPrevoznogSredstva,
        },
      ],
    },
  ];

  return (
    <div className={style.container}>
      <div className={style.innerContainer}>
        <GoBackButton
          routePath={goBackRoute}
          options={{ state: { usePersistedFilters: true } }}
        />
        <Row className={style.row}>
          <Col span={12} className={style.leftColFirst}>
            {t("PU_OBRASCI.SEKCIJA")}
          </Col>
          {/* <Col className={style.rightColFirst}>{t("PU_OBRASCI.NAZIV_POLJA")}</Col> */}
          <Col span={12} className={style.rightColFirst}></Col>
        </Row>

        {obrazacSectionConfig.map((config) => (
          <ObrazacSection {...config} />
        ))}

        <Row className={style.row}>
          <Col span={12} className={style.leftCol}>
            {t(`PU_OBRASCI.PODACI_O_UVEZENOJ_ROBI`)}
          </Col>
          <Col span={12} className={style.rightCol}>
            {obrazac?.uvezenaRoba &&
              obrazac?.uvezenaRoba.map(({ redniBroj, oznakaIBroj }) => (
                <>
                  <LabelValueRow label="REDNI_BROJ" value={redniBroj} />
                  <LabelValueRow
                    label="PAKOVANJE_NAIMENOVANJE"
                    value={oznakaIBroj}
                  />
                </>
              ))}
          </Col>
        </Row>
      </div>
    </div>
  );
};
